
import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { useGLTF, useScroll } from '@react-three/drei'
import gsap from 'gsap'
import { useFrame } from '@react-three/fiber'

export function Astronaut(props) {
  const { nodes, materials } = useGLTF('/models/astronaut/scene.gltf')

  const ref = useRef()
  const tl = useRef()
  const tl2 = useRef()

  const scroll = useScroll()

  let state = 'IDLE'

  useFrame(()=>{
    tl.current.seek((scroll.offset / 3) * (tl.current.duration()))
  })

  useEffect(()=>{
    if(props.call){
      console.log(props.call)
        // gsap.to(ref.current.rotation, {duration:0.5,x:props.call,ease: "linear",})
    }
  },[props.call])

  useLayoutEffect(()=>{
   
    tl.current = gsap.timeline({duration:6})

    // tl2.current = gsap.timeline({repeat:-1})
    // tl2.current.to(ref.current.rotation, {duration:10,y:6.4,ease: "linear",},0)

    // console.log(ref.current.rotation.y)


        tl.current.to(ref.current.rotation, {duration:1,y:0.8,ease: "linear",},0)
        tl.current.to(ref.current.position, {duration:1, y:50, z:0,ease: "linear",},0)
        tl.current.to(ref.current.scale, {duration:1, x:1.2, y:1.2, z:1.2,ease: "linear",},0)

        tl.current.to(ref.current.rotation, {duration:1,x:0, y:1.3, z:0, ease: "linear", onComplete:()=>{console.log("1")}}, 1)
        tl.current.to(ref.current.position, {duration:1, x:-10, y:10, z:-70,ease: "linear", onComplete:()=>{console.log("1")}},1)
        tl.current.to(ref.current.scale, {duration:1, x:0.5, y:0.5, z:0.5,ease: "linear", onComplete:()=>{console.log("1") }},1)


        // tl.current.to(ref.current.rotation, {duration:1,y:3.8,ease: "linear", onComplete:()=>{console.log("2")}}, 2)
        // tl.current.to(ref.current.position, {duration:1, y:200, x:0, z:0,ease: "linear", onComplete:()=>{console.log("2")}},2)
        // tl.current.to(ref.current.scale, {duration:1, x:3, y:3, z:3, ease: "linear", onComplete:()=>{console.log("2") }},2)

        // tl.current.to(ref.current.scale, {duration:1,x:0.1, y:0.1, z:0.1,ease: "linear"},5)

     

        // tl.current.to(ref.current.scale, {duration:1, x:0.5, y:0.5, z:0.5,ease: "linear", delay:9, onComplete:()=>{console.log("2") }},2)
     
        
        // tl.current.fromTo(".services-frame", { opacity: 0 }, { opacity: 1, duration: 1 }, 2);
    return () => {}

  },[])
  return (
    <group {...props} dispose={null} ref={ref}>
      <group >
        <group position={[0,-300,50]} rotation={[0, 2.5, 0]} scale={1.5}>
        
         {/* <group> */}
          <primitive object={nodes._rootJoint} />
          <skinnedMesh
            geometry={nodes.Object_6.geometry}
            material={materials.SuitMat}
            skeleton={nodes.Object_6.skeleton}
          />
          <skinnedMesh
            geometry={nodes.Object_7.geometry}
            material={materials.BackpackMat}
            skeleton={nodes.Object_7.skeleton}
          />
          <skinnedMesh
            geometry={nodes.Object_8.geometry}
            material={materials.HelmetMat}
            skeleton={nodes.Object_8.skeleton}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/astronaut/scene.gltf')